import { SubApp } from '@lenovo/micro-frontends-iframe/container-app/container-app.service';
import { SubAppName } from './sub-app-name.enum';

export const subAppListForInit: SubApp[] = [
	{
		name: SubAppName.ModernPreload,
		config: {
			url: 'https://vantage-2.csw-qa.lenovo.com/v1/web/modernpreload/default',
			origin: 'https://vantage-2.csw-qa.lenovo.com/v1/web/modernpreload/default',
			isAvailable: true,
			isPreloadEnabled: false,
			isAutoDestroyEnabled: false,
			entryUrls: ['device/modern-preload'],
			isCrossOrigin: true,
		},
	},
];
